import { DescriptionRunResultDTO } from "@app/api/generated";
import { IRunCounter } from "@app/util/run-counters";

/**
 * The run counters in a fixed display order. Written = green, left empty = yellow (worth a look,
 * not broken), errors = red; grounded and searches are informative, so grey.
 */
export const RUN_COUNTERS: Array<IRunCounter<DescriptionRunResultDTO>> = [
  {
    key: "generated",
    labelId: "productDescription.counter.generated",
    shortId: "productDescription.counter.generatedShort",
    color: "green"
  },
  {
    key: "skipped",
    labelId: "productDescription.counter.skipped",
    shortId: "productDescription.counter.skippedShort",
    color: "yellow"
  },
  {
    key: "grounded",
    labelId: "productDescription.counter.grounded",
    shortId: "productDescription.counter.groundedShort",
    color: "grey"
  },
  {
    key: "searchQueries",
    labelId: "productDescription.counter.searchQueries",
    shortId: "productDescription.counter.searchQueriesShort",
    color: "grey"
  },
  {
    key: "errorCount",
    labelId: "productDescription.counter.errors",
    shortId: "productDescription.counter.errorsShort",
    color: "red"
  }
];
